import React, { FC } from 'react'
import { CreateProps, Create, SimpleForm } from 'react-admin'
import { makeStyles } from '@material-ui/core'

import { Drawers, Form, CreateCourseToolbar } from '../containers'

const useStyles = makeStyles({
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
})

export const CreateLesson: FC<CreateProps> = (props) => {
  const classes = useStyles()

  return (
    <>
      <Drawers {...props} />

      <Create {...props}>
        <SimpleForm warnWhenUnsavedChanges className={classes.formContainer}>
          <Form toolbar={<CreateCourseToolbar />} />
        </SimpleForm>
      </Create>
    </>
  )
}
